import {isOnlineEnv} from './env';
import {getPagePath} from '@/router/routerUtil';
import {LOGIN} from '@/enmus/PageNames';

const onlineUuapConfig = {
    origin: 'https://uuap.baidu.com',
    appKey: 'uuapclient-3-oisJsCgPVFOzY7jdp7fB'
};

const offlineUuapConfig = {
    origin: 'https://itebeta.baidu.com',
    appKey: 'uuapclient-5-DrgEVRYXBDQ5dclsjLfL'
};

const sTokenBackendValidatePath = '/api/sTokenBackendValidate';
const uuapConfig = isOnlineEnv ? onlineUuapConfig : offlineUuapConfig;

export const logoutService = `${location.origin}${getPagePath(LOGIN)}`;

export const logoutUrl = `${uuapConfig.origin}/logout?appKey=${uuapConfig.appKey}&service=${
    encodeURIComponent(logoutService)
}`;

export function getUuapLoginUrl(redirectUrl = '') {
    const loginService = encodeURIComponent(`${
        location.origin
    }${sTokenBackendValidatePath}?originalUrl=${encodeURIComponent(redirectUrl)}`);
    return `${uuapConfig.origin}/login?service=${loginService}&appKey=${uuapConfig.appKey}&version=v2`;
}
